import { render, staticRenderFns } from "./xpscontact.vue?vue&type=template&id=a7306200"
import script from "./xpscontact.vue?vue&type=script&lang=js"
export * from "./xpscontact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports